import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FitText } from '@gojiraf/responsive'
import CalendarSVG from '../../../static/calendar.svg'
import { CircularProgress } from '@material-ui/core'

const EventDate = ({ children, onClick, disabled }) => {
  return (
    <DateContainer disabled={disabled} onClick={onClick}>
      {disabled ? (
        <CircularProgress size="1.5rem" color="secondary" />
      ) : (
        <>
          <img src={CalendarSVG}></img>
          <StyledText>
            <FitText min={9}>{children}</FitText>
          </StyledText>
        </>
      )}
    </DateContainer>
  )
}

const DateContainer = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 1.25rem;
  border: none;
  background-color: #f93700;
  padding: 8px 25px;
  color: #ffffff;
  margin: 10px 0;
  /* border-box: la app corre en content-box (default); sin esto,
     max-width:100% permite desbordar por el padding */
  box-sizing: border-box;
  max-width: 100%;

  img {
    flex-shrink: 0;
  }
`

const StyledText = styled.span`
  font-weight: 600;
  font-size: 0.75rem;
  align-self: center;
  min-width: 0;
`

EventDate.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export { EventDate }
